import { MdCall, MdEmail } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { ReactComponent as DefaultLogoIcon } from 'images/icons/inspiretec_white_logo.svg';
import {
  DEFAULT_PRIMARY_COLOUR,
  DEFAULT_SECONDARY_COLOUR,
} from 'shared/constants/styleConstants';
import PageContentContainer from './PageContentContainer';

export default function QuoteLinkFooter({
  brandLogo,
  phoneNumber,
  emailAddress,
  privacyPolicyUrl,
  termsAndConditionsUrl,
  travelQAndAUrl,
  copyrightMessage,
}) {
  const { theme } = useSelector((state) => state.ui);
  let logo;
  if (brandLogo) {
    const logoUrl = `/api/v1.10/content/${encodeURIComponent(brandLogo)}`;
    logo = <img src={logoUrl} alt="logo" className="h-10" />;
  } else {
    logo = <DefaultLogoIcon className="h-10" />;
  }

  return (
    <PageContentContainer
      style={{
        backgroundColor: theme.secondaryColour || DEFAULT_PRIMARY_COLOUR,
      }}
    >
      <div className="content-spacer xs:pr-[4rem] flex justify-between text-white flex-col xs:flex-row md:grid md:grid-cols-3 lg:flex lg:flex-row lg:justify-start lg:items-start lg:gap-x-6">
        <div className="mb-7 xs:mb-0 md:mb-8 lg:mb-0 md:col-span-3 md:flex md:items-center lg:items-start md:justify-between md:border-b md:border-white/25 lg:border-none lg:flex-col md:pb-5 lg:pb-0 lg:w-[25%]">
          {logo}
          <p className="hidden md:inline lg:hidden font-medium">Contact</p>
          <div className="flex my-4 items-center">
            <div
              style={{ color: theme.brandColour || DEFAULT_SECONDARY_COLOUR }}
              className="mt-1 mr-2 text-md lg:mt-0"
            >
              <MdCall />
            </div>
            <p className="text-base">{phoneNumber || ''}</p>
          </div>
          <div className="flex my-4 items-center">
            <div
              style={{ color: theme.brandColour || DEFAULT_SECONDARY_COLOUR }}
              className="mt-1 mr-2 text-md lg:mt-0"
            >
              <MdEmail />
            </div>
            <p className="text-base">{emailAddress || ''}</p>
          </div>
        </div>

        <div className="border-t border-white/25 xs:border-none md:col-span-1 lg:w-[25%]">
          <p className="text-[22px] font-medium mb-4 mt-3 xs:mt-0">
            Information
          </p>
          <p className="text-base my-4">
            <a href={travelQAndAUrl || '/'} rel="noreferrer" target="_blank">
              Travel Q&A
            </a>
          </p>
          <p className="text-base my-4">
            <a href={privacyPolicyUrl || '/'} rel="noreferrer" target="_blank">
              Privacy Policy
            </a>
          </p>
          <p className="text-base my-4">
            <a
              href={termsAndConditionsUrl || '/'}
              rel="noreferrer"
              target="_blank"
            >
              Terms and conditions
            </a>
          </p>
        </div>
      </div>
      <div className="flex flex-col xs:flex-row justify-between py-8 border-t border-white/25 text-white mx-4">
        <div className="mb-2.5 xs-mb-0">
          <p>{copyrightMessage || ''}</p>
        </div>
        <div>
          <p className="underline underline-offset-4 hidden">ENGLISH</p>
        </div>
      </div>
    </PageContentContainer>
  );
}
